module.exports = __webpack_public_path__ + "img/output_more.72ce7509.png";